/**
 * Her build path: the assets NOVA builds with her, in catalog order. Paid
 * NOVA Home draws it, and the weekly check-in falls back to its next step.
 *
 * Aliases: build path, steps panel path, next build step
 */

import type { AssetKey, AssetSurface } from "./catalog";
import { isRoutineAsset } from "./catalog";
import type { AssetStatus } from "./status";

/**
 * Statuses that take an asset off her path: it does not exist yet, or her
 * plan does not open it. Every other status is a step she can work on or has
 * finished, including `not_yet`, whose page names what it waits on.
 */
const OFF_THE_PATH: ReadonlySet<AssetStatus> = new Set<AssetStatus>([
  "coming_soon",
  "with_your_trial",
  "locked_churned",
]);

/**
 * On the path: a My assets entry she can work on or has finished. Content
 * collections stay off it, because a post or an article is never finished,
 * and so do routines, which she runs every week rather than builds.
 */
export function isOnBuildPath(asset: {
  readonly key: AssetKey;
  readonly surface: AssetSurface;
  readonly status: AssetStatus;
}): boolean {
  return (
    asset.surface === "assets" &&
    !OFF_THE_PATH.has(asset.status) &&
    !isRoutineAsset(asset.key)
  );
}
